import React from "react";
import { useOverlays } from "contexts/OverlayContext";
import { DeleteGroupModal } from "./DeleteGroupModal";

export const DeleteGroupModalWrapper: React.FC = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo<"deleteCoaGroup">("deleteCoaGroup");

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <DeleteGroupModal
            show={!overlayIsClosing}
            onHide={closeOverlay}
            name={overlayInfo.data.name}
            groups={overlayInfo.data.groups}
        />
    );
};
